import { useState } from "react";
import { toast } from "sonner";
import { Ban, Trash2 } from "lucide-react";
import { Field, BigButton } from "@/components/Field";
import { Panel, SelectField, Empty, ConfirmDelete } from "@/components/Bits";
import { useFetch, fmtDate } from "@/lib/useFetch";
import { api, errMsg } from "@/lib/api";

const TIPOS = [{ value: "cpf", label: "CPF/CNPJ" }, { value: "email", label: "E-mail" }, { value: "ie", label: "Inscrição estadual" }];

export const BloqueiosTab = () => {
  const { data, reload } = useFetch("/bloqueios");
  const [f, setF] = useState({ tipo: "cpf", valor: "", motivo: "" });
  const [ask, setAsk] = useState(false);
  const [del, setDel] = useState(null);
  const block = async () => {
    try {
      const { data: r } = await api.post("/bloqueios", f);
      toast.success(`Bloqueado. ${r.contas_bloqueadas} conta(s) desativada(s).`);
      setF({ tipo: f.tipo, valor: "", motivo: "" });
      setAsk(false);
      reload();
    } catch (e) { toast.error(errMsg(e)); setAsk(false); }
  };
  const remove = async () => { try { await api.delete(`/bloqueios/${del.bloqueio_id}`); setDel(null); reload(); } catch (e) { toast.error(errMsg(e)); } };
  return (
    <div className="space-y-5" data-testid="bloqueios-tab">
      <Panel title="Bloquear cliente">
        <form onSubmit={(e) => { e.preventDefault(); setAsk(true); }} className="grid sm:grid-cols-[200px_1fr] gap-3">
          <SelectField label="Bloquear por" id="bl-tipo" value={f.tipo} onChange={(e) => setF({ ...f, tipo: e.target.value })} options={TIPOS} data-testid="bloqueio-tipo" />
          <Field label="Valor *" id="bl-valor" required minLength={3} value={f.valor} onChange={(e) => setF({ ...f, valor: e.target.value })} data-testid="bloqueio-valor" />
          <div className="sm:col-span-2"><Field label="Motivo" id="bl-mot" value={f.motivo} onChange={(e) => setF({ ...f, motivo: e.target.value })} data-testid="bloqueio-motivo" /></div>
          <div className="sm:col-span-2"><BigButton type="submit" className="!bg-[#B05A40] hover:!bg-[#8f4733]" data-testid="bloqueio-submit"><Ban className="h-5 w-5" /> Bloquear</BigButton></div>
        </form>
        <p className="text-xs text-[#5C6B66] mt-3">O cliente bloqueado perde o acesso imediatamente e não consegue entrar, se cadastrar novamente ou entrar com Google.</p>
      </Panel>
      <Panel title={`Bloqueados (${data?.length ?? 0})`}>
        {data?.length === 0 && <Empty>Nenhum bloqueio.</Empty>}
        <div className="space-y-2">
          {(data || []).map((b) => (
            <div key={b.bloqueio_id} className="rounded-2xl border border-[#E2DDD3] p-4 flex items-center gap-3" data-testid={`bloqueio-item-${b.bloqueio_id}`}>
              <Ban className="h-5 w-5 text-[#B05A40] shrink-0" />
              <div className="min-w-0 flex-1"><p className="font-semibold truncate">{b.tipo_label}: {b.valor_exibicao}</p>
                <p className="text-xs text-[#5C6B66] truncate">{fmtDate(b.created_at)} · {b.created_by}{b.motivo ? ` · ${b.motivo}` : ""}</p></div>
              <button onClick={() => setDel(b)} aria-label="Remover bloqueio" className="h-11 w-11 rounded-xl border border-[#E2DDD3] flex items-center justify-center" data-testid={`bloqueio-delete-${b.bloqueio_id}`}><Trash2 className="h-4 w-4" /></button>
            </div>
          ))}
        </div>
      </Panel>
      <ConfirmDelete open={ask} onOpenChange={setAsk} title="Confirmar bloqueio?" description={`${f.valor} perderá o acesso ao aplicativo definitivamente.`} onConfirm={block} />
      <ConfirmDelete open={!!del} onOpenChange={(o) => !o && setDel(null)} title="Remover bloqueio?" description="Novos cadastros com este dado voltarão a ser permitidos. As contas desativadas continuam bloqueadas." onConfirm={remove} />
    </div>
  );
};
